import { render, staticRenderFns } from "./product_details.vue?vue&type=template&id=b8030fb2&"
import script from "./product_details.vue?vue&type=script&lang=js&"
export * from "./product_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports